import { render } from "./Alerts.vue?vue&type=template&id=329a2ad8"
import script from "./Alerts.vue?vue&type=script&lang=js"
export * from "./Alerts.vue?vue&type=script&lang=js"
script.render = render

export default script